import { render, staticRenderFns } from "./promotion-add.vue?vue&type=template&id=2bd7f52f"
import script from "./promotion-add.vue?vue&type=script&lang=js"
export * from "./promotion-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports